import {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_MEASUREMENT_ID,
  REACT_APP_FIREBASE_PDF_STORAGE_BUCKET,
  REACT_APP_FIREBASE_PROJECT_ID
} from 'constants/envs'

import { initializeApp, getApps } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { initializeFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: REACT_APP_FIREBASE_PDF_STORAGE_BUCKET,
  appId: REACT_APP_FIREBASE_APP_ID,
  measurementId: REACT_APP_FIREBASE_MEASUREMENT_ID,
}

let app

if (getApps().length === 0) {
  app = initializeApp(firebaseConfig, '[AUTH]')
  initializeFirestore(app, { experimentalAutoDetectLongPolling: true })
}
else {
  app = getApps()[0]
}

export const firebaseAuthClient = getAuth(app)

// PDF Storage - uses identity project bucket (same project as auth)
const pdfStorageBucket = REACT_APP_FIREBASE_PDF_STORAGE_BUCKET

const pdfBucketUrl = REACT_APP_FIREBASE_PDF_STORAGE_BUCKET.startsWith('gs://')
  ? pdfStorageBucket
  : `gs://${pdfStorageBucket}`

export const firebasePdfStorage = getStorage(app, pdfBucketUrl)
